<template>
	<code-index cardClass="col-12 col-md-6 col-xl-3" />
</template>